import React, { Component } from "react";
import NotFound from "../../pages/NotFound/NotFound";

interface IErrorBoundary {
  hasError: boolean;
}

class ErrorBoundary extends Component<{}, IErrorBoundary> {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.log(error);
  }

  render() {
    if (this.state.hasError) {
      return <NotFound notFound={false} />;
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
